class ct_rs extends HTMLElement {
  constructor() {
    super();
    const scrollContainer = this.querySelector(".ct-rs-slides");
    this.slides = Array.from(scrollContainer.children);
    this.isScrolling = false;
    this.updateActiveSlide();
    scrollContainer.addEventListener("scroll", () => {
      this.updateActiveSlide();
      this.isScrolling = true;
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        this.isScrolling = false;
      }, 300);
    });
    Array.from(scrollContainer.children).forEach((item) => {
      item.addEventListener("click", () => {
        if(!this.isScrolling) {
          this.handleClick(item);
          this.isScrolling = true;
          setTimeout(() => {
            this.isScrolling = false;
          }, 200);
        }
      });
    });
    this.querySelector(".ct-rs-pagination svg[left]").addEventListener("click", () => {
      if (!this.isScrolling) {
        this.isScrolling = true;
        scrollContainer.scrollBy({
          left: -scrollContainer.children[0].offsetWidth,
          behavior: "smooth"
        });
        setTimeout(() => {
          this.isScrolling = false;
        }, 300);
      }
    });
    this.querySelector(".ct-rs-pagination svg[right]").addEventListener("click", () => {
      if (!this.isScrolling) {
        this.isScrolling = true;
        scrollContainer.scrollBy({
          left: scrollContainer.children[0].offsetWidth,
          behavior: "smooth"
        });
        setTimeout(() => {
          this.isScrolling = false;
        }, 300);
      }
    });
  }
  handleClick(element) {
    const scrollContainer = this.querySelector(".ct-rs-slides");
    const lastChild = scrollContainer.children[scrollContainer.children.length - 1];
    const firstChild = scrollContainer.children[0];
    if(element.previousElementSibling?.hasAttribute("active")) {
      if(element != lastChild) {
        scrollContainer.scrollBy({
          left: lastChild.offsetWidth,
          behavior: "smooth"
        });
      }
    } else if (element.nextElementSibling?.hasAttribute("active")) {
      if(element != firstChild) {
        scrollContainer.scrollBy({
          left: -lastChild.offsetWidth,
          behavior: "smooth"
        });
      }
    }
  }
  
  updateActiveSlide() {
    const scrollContainer = this.querySelector(".ct-rs-slides");
    const containerRect = scrollContainer.getBoundingClientRect();
    const centerX = containerRect.left + containerRect.width / 2;
    let closestSlide = null;
    let closestDistance = Infinity;
    this.slides.forEach(slide => {
      const slideRect = slide.getBoundingClientRect();
      const slideCenterX = slideRect.left + slideRect.width / 2;
      const distance = Math.abs(centerX - slideCenterX);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestSlide = slide;
      }
    });
    this.slides.forEach(slide => {
      if (slide === closestSlide) {
        slide.setAttribute("active", "");
        slide.nextElementSibling?.removeAttribute("invisible");
        slide.previousElementSibling?.removeAttribute("invisible");
        if(slide.nextElementSibling?.nextElementSibling) {
          slide.nextElementSibling.nextElementSibling.setAttribute("invisible", "");
        } else {
          const dots = this.querySelector(".ct-rs-pagination-dots");
          Array.from(dots.children).forEach((dot) => {
            dot.removeAttribute("active");
          });
          dots.children[dots.children.length - 1].setAttribute("active", "");          
        }
        if(slide.previousElementSibling?.previousElementSibling) {
          slide.previousElementSibling.previousElementSibling.setAttribute("invisible", "");
        } else {
          const dots = this.querySelector(".ct-rs-pagination-dots");
          Array.from(dots.children).forEach((dot) => {
            dot.removeAttribute("active");
          });
          dots.children[0].setAttribute("active", "");
        }
        if(slide.nextElementSibling?.nextElementSibling && slide.previousElementSibling?.previousElementSibling) {
          const dots = this.querySelector(".ct-rs-pagination-dots");
          Array.from(dots.children).forEach((dot) => {
            dot.removeAttribute("active");
          });
          dots.children[1].setAttribute("active", "");
        } else {
          if(window.innerWidth <= 730) {
            if(slide.nextElementSibling && slide.previousElementSibling) {
              const dots = this.querySelector(".ct-rs-pagination-dots");
              Array.from(dots.children).forEach((dot) => {
                dot.removeAttribute("active");
              });
              dots.children[1].setAttribute("active", "");
            }
          }
        }
      } else {
        slide.removeAttribute("active");
      }
    });
  }
}
customElements.define("ct-rs", ct_rs);